/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { titleCase } from 'services/Formats';

export const ANALYTICS_PAGE_LOAD = 'ANALYTICS_PAGE_LOAD';
export const analyticsPageLoaded = (page) => {
  return {
    type: ANALYTICS_PAGE_LOAD,
    page
  };
};

export const ANALYTICS_PAGE_OVERLAY_LOAD = 'ANALYTICS_PAGE_OVERLAY_LOAD';
export const analyticsPageOverlayLoaded = (overlay) => {
  return {
    type: ANALYTICS_PAGE_OVERLAY_LOAD,
    overlay
  };
};
export const ANALYTICS_ACTION_SUCCESS = 'ANALYTICS_ACTION_SUCCESS';
export const analyticsActionSuccess = (action, message) => {
  let type = action;
  if (action && action.startsWith('RECEIVED_')) {
    type = titleCase(action.slice('RECEIVED_'.length), '_', '');
  }
  return {
    type: ANALYTICS_ACTION_SUCCESS,
    action: action ? `${type}|${message}` : message
  };
};

export const ANALYTICS_ACTION_ERROR = 'ANALYTICS_ACTION_ERROR';
export const analyticsActionError = (action) => {
  let type = action;
  const message = 'Error Saving Changes'
  if(action && action.startsWith('ERROR_')) {
    type = titleCase(action.slice('ERROR_'.length), '_', '');
  }
  return {
    type: ANALYTICS_ACTION_ERROR,
    message: action ? `${type}|${message}` : message
  };
};
